"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionEdit = /** @class */ (function (_super) {
    __extends(TableActionEdit, _super);
    function TableActionEdit(props) {
        return _super.call(this, props) || this;
    }
    TableActionEdit.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    TableActionEdit.prototype.getButtonRenderObject = function () {
        if (this.props.square) {
            return (React.createElement(antd_1.Button, { size: "small", icon: "form", ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" }, onClick: this.buttonClick.bind(this), disabled: this.props.disabled }));
        }
        else {
            return (React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: "form", ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" }, onClick: this.buttonClick.bind(this), disabled: this.props.disabled }));
        }
    };
    TableActionEdit.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" }, this.getButtonRenderObject()));
    };
    return TableActionEdit;
}(React.Component));
exports.default = TableActionEdit;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_actions/TableActionEdit.tsx
// module id = 18
// module chunks = 0